module.exports = require('./helpers/bundle-url').getBundleURL('hmjwG') + "k8s-logo.723aeb15.png";